import PropTypes from 'prop-types'
import React from 'react'

import {
    helpers,
    IndustrialResource,
} from 'react-wot-bootstrap'


const propTypes = {
    ...IndustrialResource.propTypes,
    amount: PropTypes.number,
}

const FormattedIndustrialResource = ({ amount, ...props }) => (
    <IndustrialResource {...props}>{helpers.thousands(amount)}</IndustrialResource>
)
FormattedIndustrialResource.propTypes = propTypes

export default FormattedIndustrialResource



// WEBPACK FOOTER //
// ./containers/ClanManagement/components/FormattedIndustrialResource/FormattedIndustrialResource.js